<template>
    <div>
    <div class="reroute amTealregular">Searching for Artist Profile</div>
    </div>
</template>

<script>
// import firebase from 'firebase/app'
// import db from '../main'
export default {
    name: 'index',
      metaInfo: {
    title: "Artmuseo | Curate an Artful Life",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale = 1.0,maximum-scale = 1.0, viewport-fit=cover, user-scalable=no", zoom: "fixed"},
      { charset: 'utf8'},
      { property:"og:image", content: "<%= BASE_URL %>ammetaimg.png" },
      { title: 'Artmuseo | Curate an Artful Life' }
    ]
  },
    data(){
        return {
            blockarr: ["salon", "signup", "artmarket", "artmuseo", "artscene", "events", "notifications", "messages", "chat", ""]
        }
    },
    created(){
        const path = this.$route.params.pathMatch
        const lookup = path.substring(1)
        
        const countof = lookup.length

        if (lookup == "artmuseo" || undefined){
            location.replace('https://artmuseo.com')
        } else {
            if (countof > 3){
            const userq = lookup.toLowerCase()
            const artisturl = 'https://artmuseo.com/artists/?id=' + userq
            console.log(artisturl)
           location.replace(artisturl, "_self")
        } else {
            location.replace('https://artmuseo.com')
        }
        }
    }
    // beforeCreate(){
    //     const art = 'https://artmuseo.com'
    //    window.open(art.href,"_self");
    // }
}
</script>

<style scoped>
.reroute{
    width: 100vh;
    height: 100vh;
    background-color: #00a89d;
    color: white;
    text-align: center;
    padding-top: 200px;
    font-family:Arial, Helvetica, sans-serif
}
</style>